const CropImages = {
  generateCropped(maxWidth, maxHeight, srcImage, nameImage, typeImage) {
    return new Promise((resolve) => {
      const img = document.createElement("img");
      const canvas = document.createElement("canvas");

      img.src = srcImage
      img.onload = function () {
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(function (blob) {
          blob.lastModifiedDate = new Date();
          blob.name = nameImage;
          resolve(blob)
        }, typeImage, 1);
      }
    })
  },
  crop(blob, maxWidth, maxHeight, nameImage, typeImage) {
    return new Promise((resolve) => {
      const self = this

      var reader = new FileReader();
      reader.onload = async function(e) {
        const imgCropped = await self.generateCropped(maxWidth, maxHeight, e.target.result, nameImage, typeImage);
        resolve(imgCropped)
      }
      reader.readAsDataURL(blob); // convert to base64 string
    })
  }
}

export default CropImages